export const REPORT_NAMES = {
  MEDIA_STATUS_REPORT: "Media Status Report — Operations",
  MEDIA_STATUS_REPORT_SALES: "Media Status Report — Sales",
  CAMPAIGN_SCHEDULE_STATUS_REPORT: "Campaign Schedule Status Report",
};
